import { Dispatch, ReactNode, createContext, useContext, useMemo, useReducer } from "react"

import {
    FormPageActionInterface,
    FormPageStateInterface,
    INITIAL_STATE,
    reducer,
} from "modules/Booking/FormPage/common/reducer"
import { UserAccount } from "utils/UserAccount"

interface FormPageContextValue {
    form: FormPageStateInterface
}

interface FormPageContextHandlers {
    dispatch: Dispatch<FormPageActionInterface>
}

const FormPageContext = createContext<[FormPageContextValue, FormPageContextHandlers] | null>(null)

interface Props {
    children: ReactNode
}

export function FormPageProvider({ children }: Props) {
    const [form, dispatch] = useReducer(reducer, {
        ...INITIAL_STATE,
        name: UserAccount.name || "",
        phone: UserAccount.phone || "",
        email: UserAccount.email || "",
    })

    const handlers = useMemo(() => ({ dispatch }), [])

    return (
        <FormPageContext.Provider
            value={[
                {
                    form,
                },
                handlers,
            ]}
        >
            {children}
        </FormPageContext.Provider>
    )
}

export function useFormPageContext() {
    const currentContext = useContext(FormPageContext)

    if (!currentContext) {
        throw new Error("useFormPageContext has to be used within <FormPageContext.Provider>")
    }
    return currentContext
}
